'use client'

import { useState } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { LuMenu } from 'react-icons/lu'

import { Button } from '@/core/components/form/button/button'

import { MOBILE_NAV } from '../nav'

const Dialog = dynamic(() => import('@/core/components/dialog'), {
  ssr: false,
})

export default function MobileNav() {
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-label="메뉴 열기"
        onClick={() => {
          setMounted(true)
          setOpen(true)
        }}
        className="-ml-2 px-2 over10:hidden"
      >
        <LuMenu aria-hidden="true" className="size-6" />
      </Button>
      {mounted && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          mode="drawer"
          title="메뉴"
          ariaLabel="전체 메뉴"
        >
          <nav aria-label="모바일 메뉴" className="flex flex-col gap-6 pb-8">
            {MOBILE_NAV.map((group) => (
              <div key={group.title}>
                <p className="text-c13 font-semibold text-description">
                  {group.title}
                </p>
                <ul className="mt-1">
                  {group.items.map((item) => (
                    <li key={item.href}>
                      <Link
                        href={item.href}
                        onClick={() => setOpen(false)}
                        className="block py-2.5 text-c16 font-medium"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </Dialog>
      )}
    </>
  )
}
